import { render, staticRenderFns } from "./ManageRolesModal.vue?vue&type=template&id=900fb41e&scoped=true&"
import script from "./ManageRolesModal.vue?vue&type=script&lang=js&"
export * from "./ManageRolesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "900fb41e",
  null
  
)

export default component.exports